// features/loading/loadingSlice.js
import { createSlice } from '@reduxjs/toolkit';

const loadingSlice = createSlice({
  name: 'loading',
  initialState: false, // single boolean value
  reducers: {
    setLoadingTrue: () => true,
    setLoadingFalse: () => false,
  },
});

export const { setLoadingTrue, setLoadingFalse } = loadingSlice.actions;
export default loadingSlice.reducer;
